import React, { useState } from 'react';
import { Button, Typography, Switch, Input, InputNumber, Form } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setVehicleDrivable, setAdditionalInformation, setCurrentMileage } from '../../../redux/reducers/vehicleSlice';
import './VehicleStatusStep.css';

const { Title } = Typography;
const { TextArea } = Input;

interface VehicleStatusStepProps {
  onNext: () => void;
  onPrevious: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
}

const VehicleStatusStep: React.FC<VehicleStatusStepProps> = ({
  onNext,
  onPrevious,
}) => {
  const dispatch = useAppDispatch();
  const vehicle = useAppSelector((state) => state.vehicle);
  const [localNotes, setLocalNotes] = useState(vehicle.additionalInformation || '');

  return (
    <div className="step-container vehicle-status-container">
      <Title level={5} style={{ textAlign: 'center' }}>Vehicle Status</Title>

      <div className="vehicle-status-step">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <Title level={5} style={{ margin: 0 }}>Is the vehicle drivable?</Title>
            <Switch
              checked={vehicle.vehicleIsDrivable}
              onChange={(checked) => dispatch(setVehicleDrivable(checked))}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <Title level={5}>Current Mileage</Title>
            <Form layout="vertical">
              <Form.Item
                help={vehicle.vehicle?.mileage ? `Last recorded: ${vehicle.vehicle.mileage.toLocaleString()} miles` : undefined}
              >
                <InputNumber<number>
                  size="large"
                  style={{ width: '100%' }}
                  value={vehicle.currentMileage || vehicle.vehicle?.mileage}
                  onChange={(value) => { if (value != null) dispatch(setCurrentMileage(value)); }}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => parseInt(value!.replace(/\$\s?|(,*)/g, '') || '0')}
                  min={0}
                  precision={0}
                />
              </Form.Item>
            </Form>
          </div>

          <div>
            <Title level={5}>Additional Information</Title>
            <TextArea
              rows={4}
              value={localNotes}
              onChange={(e) => {
                setLocalNotes(e.target.value);
                dispatch(setAdditionalInformation(e.target.value));
              }}
              placeholder=""
              maxLength={1000}
              showCount
            />
          </div>
      </div>

      <div className="step-actions" style={{ marginTop: 40 }}>
        <Button size="large" onClick={onPrevious} style={{ color: '#FF9902', fontWeight: 'bold' }}>PREVIOUS</Button>
        <Button type="primary" size="large" onClick={onNext} style={{ fontWeight: 'bold' }}>CONTINUE</Button>
      </div>
    </div>
  );
};

export default VehicleStatusStep;
